import { useAuthRoles } from 'hooks/useAuthRoles'
import { useGetAccountsQuery } from 'store/account/accountApiWithQuery'

export const useAccounts = (jwtToken?: string) => {
  const { isAdmin } = useAuthRoles()

  const {
    data: accounts,
    isSuccess,
    isError,
    isLoading,
  } = useGetAccountsQuery(undefined, { skip: !jwtToken })

  if (isAdmin) {
    return { accounts, isSuccess, isError, isLoading }
  }

  return {
    accounts: [],
    isSuccess: false,
    isError: false,
    isLoading: false,
  }
}
